import { Mail, Phone, MapPin, User } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Seo } from "@/components/Seo";
import { ContactForm } from "@/components/ContactForm";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <Seo
        title="Contact"
        path="/contact"
        description="Tell us about your challenge. Reach Slatech Solutions — Adam Slager, adam@slatechsolutions.com, 780-267-3294. Serving Alberta and Texas. No pressure. No obligation. Just a conversation."
      />
      {/* HERO */}
      <section className="relative pt-40 pb-16 md:pt-48 md:pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://images.pexels.com/photos/30475896/pexels-photo-30475896.jpeg"
            alt="Industrial site at night"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/85" />
        </div>
        <div className="relative max-w-7xl mx-auto px-6 md:px-12">
          <Reveal>
            <p className="text-xs font-bold tracking-[0.3em] uppercase text-blue-500 mb-5">Get In Touch</p>
            <h1 className="font-heading text-5xl sm:text-6xl md:text-7xl font-black uppercase tracking-tight text-white leading-[0.9] max-w-4xl">
              Tell us about your challenge
            </h1>
            <p className="mt-6 font-heading text-xl uppercase tracking-wide text-zinc-300">
              No pressure. No obligation. Just a conversation.
            </p>
          </Reveal>
        </div>
      </section>

      {/* CONTENT */}
      <section className="bg-background py-16 md:py-24 bg-grid">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Info */}
          <Reveal className="lg:col-span-5">
            <h2 className="font-heading text-3xl font-bold uppercase tracking-tight text-white">
              Reach out directly
            </h2>
            <p className="text-zinc-400 mt-4 leading-relaxed">
              Prefer to connect directly? Adam is happy to talk through what you're trying to source,
              solve, or build.
            </p>

            <div className="mt-10 space-y-px bg-white/10 border border-white/10">
              <div className="bg-zinc-950 p-6 flex items-center gap-4">
                <span className="text-blue-500"><User size={22} /></span>
                <div>
                  <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 font-heading">Contact</p>
                  <p className="text-white font-semibold">Adam Slager · Slatech Solutions</p>
                </div>
              </div>
              <a
                href="mailto:adam@slatechsolutions.com"
                data-testid="contact-info-email"
                className="bg-zinc-950 hover:bg-zinc-900 p-6 flex items-center gap-4 transition-colors duration-200"
              >
                <span className="text-blue-500"><Mail size={22} /></span>
                <div>
                  <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 font-heading">Email</p>
                  <p className="text-white font-semibold">adam@slatechsolutions.com</p>
                </div>
              </a>
              <a
                href="tel:7802673294"
                data-testid="contact-info-phone"
                className="bg-zinc-950 hover:bg-zinc-900 p-6 flex items-center gap-4 transition-colors duration-200"
              >
                <span className="text-blue-500"><Phone size={22} /></span>
                <div>
                  <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 font-heading">Phone</p>
                  <p className="text-white font-semibold">780-267-3294</p>
                </div>
              </a>
              <div className="bg-zinc-950 p-6 flex items-center gap-4">
                <span className="text-blue-500"><MapPin size={22} /></span>
                <div>
                  <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 font-heading">Location</p>
                  <p className="text-white font-semibold">Alberta | Texas</p>
                </div>
              </div>
            </div>
          </Reveal>

          {/* Form */}
          <Reveal delay={150} className="lg:col-span-7">
            <div className="border border-white/10 bg-zinc-950 p-8 md:p-10">
              <h2 className="font-heading text-3xl font-bold uppercase tracking-tight text-white mb-2">
                Send a message
              </h2>
              <p className="text-zinc-400 mb-8">We'll get back to you to talk through your challenge.</p>
              <ContactForm />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
